import React, { useEffect, useState } from 'react';
import moment from "moment";
import { makeStyles } from "@material-ui/core/styles";
import Utility from "../../../utility/Utility";
import ReportService from "../../../services/report-service/ReportService";
import { TextField } from '@material-ui/core';
const useStyles = makeStyles((theme) => ({
    container: {
        display: "flex",
        flexWrap: "wrap",
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200,
    },
}));
function RefundReport() {
    const [fullName, setFullName] = useState<any>("");
    const [refundsStatus, setRefundsStatus] = useState('0');
    const getInitialDate = (days: number) => {
        var newDt = new Date();
        newDt.setDate(newDt.getDate() + days);
        return moment(newDt).format("YYYY-MM-DD");
    };
    const [selectedToDate, setSelectedToDate] = React.useState(getInitialDate(0));
    const [selectedFromDate, setSelectedFromDate] = React.useState(
        getInitialDate(-30)
    );
    const [maxDate, setMaxToDate] = React.useState(getInitialDate(0));
    const [validationMessage, setvalidationMessage] = React.useState("");
    const [isValidate, setIsValidate] = React.useState(false);
    const classes = useStyles();
    const [reportData, setReportData] = useState("");
    const [pdfBytes, setpdfBytes] = useState("");
    const handleFromDateChange = (date: any) => {
        console.log(date.target.value);
        setSelectedFromDate(date.target.value);
    };

    const handleFullNameChange = (name: any) => {
        console.log("name=" + name.target.value);
        setFullName(name.target.value);
    };
    const handleToDateChange = (date: any) => {
        setSelectedToDate(date.target.value);
    };

    const CurrentDate = () => {
        var currDate = new Date();
        return new Date(currDate.getFullYear(), currDate.getMonth(), currDate.getDate());
    }
    const parseDate = (dt: Date) => {
        return new Date(dt.getFullYear(), dt.getMonth(), dt.getDate());
    }
    const getDateFromString = (date: string) => {
        var newDt = new Date(date);
        return newDt;
    };
    const ClearSearchCriteria = () => {
        setFullName("")
        setSelectedToDate(getInitialDate(0));
        setRefundsStatus('0')
        setSelectedFromDate(getInitialDate(-30));
    };
    const handleBonusStatusChange = (name: any) => {
        console.log("RefundReport=" + name.target.value);
        setRefundsStatus(name.target.value);
    };
    const Download = () => {
        var blob = Utility.b64toBlob(pdfBytes);
        var url = URL.createObjectURL(blob);
        let a = document.createElement("a");
        a.href = url;
        a.download = "Refunds Report";
        a.click();
    };
    const [showDownloadBtn, setShowDownloadBtn] = useState(false);

    const getReport = () => {
        if (
            parseDate(getDateFromString(selectedFromDate)) > CurrentDate() ||
            parseDate(getDateFromString(selectedToDate)) > CurrentDate()
        ) {

            setIsValidate(true);
            setvalidationMessage("From Date cannot be greater than To Date");
            console.log("From Date cannot be greater than To Date");
            return;
        }

        if (
            parseDate(getDateFromString(selectedFromDate)) > CurrentDate() ||
            parseDate(getDateFromString(selectedToDate)) > CurrentDate()
        ) {
            setIsValidate(true);
            setvalidationMessage("From Date and To Date cannot be in future");
            console.log("From Date and To Date cannot be in future");
            return;
        }

        setIsValidate(false);
        setvalidationMessage("");
        const frmDate = selectedFromDate;
        const toDate = moment(selectedToDate + ' ' + "23:59:59").format('MM/DD/YYYY hh:mm:ss A');
        //?fromDate=0001-01-01&toDate=0001-01-01
        ReportService.GetRefundReport(
            frmDate == "Invalid date" ? "0001-01-01" : frmDate,
            toDate == "Invalid date" ? "0001-01-01" : toDate,
            fullName, refundsStatus
        ).then((res: any) => {
            setReportData(res.data.result.reportHTML);
            setpdfBytes(res.data.result.reportBytes);
            setShowDownloadBtn(true);
        });
    };

    return (
        <div className="col-10 mt-4">
            <h3>Refunds</h3>
            <div className="pt-2">
                <form className={classes.container} noValidate>
                    <label className="m-1 ">Name :</label>
                    <input

                        className="form-control  form-control-sm"
                        type="name"
                        name="txtfullName"
                        value={fullName}
                        onChange={handleFullNameChange}
                        style={{ backgroundColor: "#fff", width: '145px' }}
                        //ref={searchForm({ required: false })}
                        placeholder="Name"
                    />
                    <label htmlFor='refunds' className="m-1">Status</label>

                    <select onChange={handleBonusStatusChange} value={refundsStatus} style={{ width: '110px' }} className="form-control form-control-sm" id="refunds" name="refunds">
                        <option value="0">Pending</option>
                        <option value="1">Approved</option>
                        <option value="2">Rejected</option>
                    </select>
                    <TextField
                        id="dateFrom"
                        label="From Date"
                        type="date"
                        value={selectedFromDate}
                        onChange={handleFromDateChange}
                        InputProps={{ inputProps: { max: selectedToDate } }}
                        //defaultValue="0001-01-01" // 0001-01-01
                        className={classes.textField}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />

                    <TextField
                        id="dateTo"
                        label="To Date"
                        type="date"
                        value={selectedToDate}
                        onChange={handleToDateChange}
                        InputProps={{ inputProps: { max: maxDate } }}
                        //defaultValue="0001-01-01"
                        className={classes.textField}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                    <button
                        color="secondary"
                        onClick={ClearSearchCriteria}
                        type="button"
                        className="btn btn-sm  float-right search-btn stnd-btn view-r-btn"
                    >
                        Reset
                    </button>
                    <button
                        color="secondary"
                        onClick={getReport}
                        type="button"
                        className="btn btn-sm  float-right search-btn stnd-btn view-r-btn"
                    >
                        View Report
                    </button>
                    {isValidate && (
                        <span className="error-msg" style={{ color: "#ff0000" }}>
                            {validationMessage}
                        </span>
                    )}
                </form>
                <div className="mt-4">
                    <div className="mb-0 heading">
                        <h5>
                            Report{" "}
                            {
                                showDownloadBtn ?
                                    <button
                                        color="secondary"
                                        onClick={Download}
                                        type="button"
                                        className="btn btn-sm btn-outline-secondary float-right"
                                    >
                                        Save as
                                    </button>
                                    :
                                    ''
                            }
                        </h5>
                    </div>
                    <div className="report-view-bx">
                        <div dangerouslySetInnerHTML={{ __html: reportData }} />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default RefundReport